import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { Grandpa } from "../../actors/characters/grandpa";

import { goToScene } from "../../main";
import Katie from "../../actors/characters/katie";
import OldMan from "../../actors/characters/oldMan";
import Sparky from "../../actors/characters/sparky";
import sparkysCommerce from "../sparkysCommerce";
import Linda from "../../actors/characters/linda";
import { playerState } from "../../state/stateManager";
import Ronald from "../../actors/characters/ronald";
import Cowboy from "../../actors/characters/cowboy";
import Bill from "../../actors/characters/bill";

export default class Sparkys extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    this.sparky = new Sparky({ x: 23 * 16, y: 7 * 16 });
    this.linda = new Linda({ x: 20 * 16, y: 10 * 16 }, "sparkys");
    this.ronald = new Ronald({ x: 26 * 16 + 8, y: 9 * 16 + 13 }, "sparkys");
  }
  onInitialize(engine) {
    engine.add("sparkysCommerce", sparkysCommerce);
    Resources.SparkysMap.addToScene(this);
    console.log("mccartys: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.sparky);
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);

    this.door = new ex.Trigger({
      pos: new ex.Vector(18 * 16, 18 * 16 + 8),
      width: 48,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 68 * 16, y: 52 * 16, direction: "down" });
      },
    });
    this.add(this.door);
    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "sparky") {
        this.sparky.startInteraction(this.player.lastDir, this.player);
      }
    });
    this.player.on("collisionstart", (e) => {
      if (e.other.owner.name === "linda") {
        this.linda.startInteraction(this.player.lastDir, this.player);
      }
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    if (content.npcLocations.linda.location == 2) {
      this.add(this.linda);
    }
    if (content.npcLocations.ronald.location == 2) {
      this.add(this.ronald);
    }
    if (content.npcLocations.cowboy.location == 2) {
      if (this.cowboy == null || this.cowboy == undefined) {
        this.cowboy = new Cowboy(
          { x: 26 * 16 + 8, y: 15 * 16 + 13 },
          "sparkys"
        );
        this.add(this.cowboy);
        this.cowboy.z = 4;
      }
    }
    if (content.npcLocations.bill.location == 2) {
      if (this.bill == null || this.bill == undefined) {
        this.bill = new Bill({ x: 17 * 16 + 8, y: 15 * 16 + 13 }, "sparkys");
        this.add(this.bill);
        this.bill.z = 4;
      }
    }
  }
  onPostUpdate() {
    //     if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
    //       if (this.computerCollision) {
    //         console.log("pressed space, should go");
    //         goToScene("onlineMarket");
    //       }
    //     }
    //   }
  }
}
